const faqs = [
  {
    q: '午马影院需要注册才能观看吗？',
    a: '不需要！午马影院坚持免费免注册观看，打开网站即可即点即播，无需填写任何个人信息或绑定手机号，真正做到零门槛观影体验。',
  },
  {
    q: '观看视频会不会卡顿？画质怎么样？',
    a: '午马影院采用先进的智能CDN加速和多线路切换技术，确保高清画质下流畅播放不卡顿。我们提供从标清到4K多种清晰度选择，系统会根据您的网络状况自动匹配最佳画质。',
  },
  {
    q: '资源更新速度如何？有新片吗？',
    a: '我们拥有专业的内容更新团队，每日更新超过200部影视资源。院线新片、热播剧集、人气综艺都会在第一时间上线，确保您不会错过任何精彩内容。',
  },
  {
    q: '支持哪些设备观看？可以投屏吗？',
    a: '午马影院全面支持电脑、平板、手机等各类设备，适配主流浏览器。同时支持DLNA和AirPlay投屏功能，可以将精彩内容投射到电视大屏上，享受家庭影院体验。',
  },
  {
    q: '播放出现问题时怎么办？',
    a: '如果遇到播放问题，可以尝试切换播放线路（播放器右下角线路切换按钮），或刷新页面。绝大部分问题都可以通过切换线路解决。如仍有问题，欢迎通过页面底部的联系方式反馈。',
  },
  {
    q: '网站有广告吗？观影体验如何？',
    a: '午马影院以用户体验为核心，采用轻度广告策略，不会出现弹窗或强制观看的广告。我们持续优化观影体验，让您享受干净、沉浸的观影环境。',
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="w-full py-14 md:py-18 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="mb-8 text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="text-foreground-600 text-sm mt-2">关于午马影院的常见疑问，这里都有解答</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <details key={i} className="group bg-background-100 rounded-xl border border-background-200/60 overflow-hidden">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">{faq.q}</h3>
                <span className="w-6 h-6 flex items-center justify-center shrink-0 text-foreground-400 group-open:hidden">
                  <i className="ri-add-line"></i>
                </span>
                <span className="w-6 h-6 items-center justify-center shrink-0 text-foreground-400 hidden group-open:flex">
                  <i className="ri-subtract-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}